(function() {
    "use strict";
    
    // Always use window._klvReady to ensure Klevu is loaded before executing
    window._klvReady = window._klvReady || [];
    window._klvReady.push(function() {
        initializeKlevuOverrides();
    });
    
    function initializeKlevuOverrides() {
        // Ensure klevu is available
        try {
            if (typeof klevu === 'undefined') {
                console.warn('Klevu is not available. Retrying...');
                setTimeout(initializeKlevuOverrides, 100);
                return;
            }
        } catch (e) {
            // klevu is not defined, retry
            console.warn('Klevu is not available. Retrying...');
            setTimeout(initializeKlevuOverrides, 100);
            return;
        }

    klevu({
        powerUp: {
            landing: false,
            catnav: false
        }
    });

    klevu.coreEvent.build({
        name: "shiftWorshipLandingOverride",
        fire: function () {
            if (klevu.getGlobalSetting("flags.setRemoteConfigLanding.build", false)) {
                return true;
            }
            return false;
        },
        maxCount: 150,
        delay: 100
    });

    klevu.coreEvent.build({
        name: "shiftWorshipCatnavOverride",
        fire: function () {
            if (klevu.getGlobalSetting("flags.setRemoteConfigCatnav.build", false)) {
                return true;
            }
            return false;
        },
        maxCount: 150,
        delay: 100
    });

    // addPaginationToURL module - Extended to handle filters and pagination
    klevu.extend(true, klevu.search.modules, {
        addPaginationToURL: {
            base: {
                /**
                 * Serialize active filters into URL format
                 * Format: category:type;Season:Fall,Winter
                 */
                serializeFilters: function(data, queryId) {
                    var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");
                    if (queryId && queryId.length) {
                        activeQueryId = queryId;
                    }
                    
                    // Try multiple possible filter storage locations
                    var filters = klevu.getObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters");
                    
                    // If not found, try alternative paths
                    if (!filters || !Array.isArray(filters) || filters.length === 0) {
                        filters = klevu.getObjectPath(data, "request.current.recordQueries[0].filters.applyFilters.filters");
                    }
                    
                    if (!filters || !Array.isArray(filters) || filters.length === 0) {
                        // Try to get filters from active facets in the template
                        var templateQuery = klevu.getObjectPath(data, "template.query." + activeQueryId);
                        if (templateQuery && templateQuery.facets) {
                            filters = [];
                            klevu.each(templateQuery.facets, function(facetIndex, facet) {
                                if (facet && facet.key && facet.items) {
                                    var selectedValues = [];
                                    klevu.each(facet.items, function(itemIndex, item) {
                                        if (item && item.selected === true && item.value) {
                                            selectedValues.push(item.value);
                                        }
                                    });
                                    if (selectedValues.length > 0) {
                                        filters.push({
                                            key: facet.key,
                                            values: selectedValues
                                        });
                                    }
                                }
                            });
                        }
                    }
                    
                    if (!filters || !Array.isArray(filters) || filters.length === 0) {
                        return "";
                    }
                    
                    var filterParts = [];
                    klevu.each(filters, function(index, filter) {
                        if (filter && filter.key && filter.values && Array.isArray(filter.values) && filter.values.length > 0) {
                            // Encode values to handle special characters
                            var encodedValues = filter.values.map(function(v) {
                                return encodeURIComponent(String(v));
                            });
                            filterParts.push(encodeURIComponent(String(filter.key)) + ":" + encodedValues.join(","));
                        }
                    });
                    
                    return filterParts.join(";");
                },
                
                /**
                 * Parse filter string from URL and convert to Klevu filter format
                 * Format: category:type;Season:Fall,Winter
                 * Returns: [{ key: "category", values: ["type"] }, { key: "Season", values: ["Fall", "Winter"] }]
                 */
                parseFiltersFromURL: function(filterString) {
                    if (!filterString || filterString.length === 0) {
                        return [];
                    }
                    
                    var filters = [];
                    var filterParts = filterString.split(";");
                    
                    klevu.each(filterParts, function(index, part) {
                        if (part && part.length > 0) {
                            var colonIndex = part.indexOf(":");
                            if (colonIndex > 0 && colonIndex < part.length - 1) {
                                try {
                                    var key = decodeURIComponent(part.substring(0, colonIndex).trim());
                                    var valuesStr = part.substring(colonIndex + 1).trim();
                                    if (key && valuesStr) {
                                        var values = valuesStr.split(",").map(function(v) {
                                            try {
                                                return decodeURIComponent(v.trim());
                                            } catch (e) {
                                                return v.trim();
                                            }
                                        }).filter(function(v) {
                                            return v.length > 0;
                                        });
                                        
                                        if (values.length > 0) {
                                            filters.push({
                                                key: key,
                                                values: values
                                            });
                                        }
                                    }
                                } catch (e) {
                                    console.warn("Error parsing filter part:", part, e);
                                }
                            }
                        }
                    });
                    
                    return filters;
                },
                
                /**
                 * Update URL with filters and pagination
                 */
                setPagination: function(data, scope, queryId) {
                    var hasPaginationEnabled = klevu.getSetting(klevu, "settings.theme.modules.pagination.searchResultsPage.enable");
                    if (hasPaginationEnabled === true) {
                        var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");
                        if (queryId && queryId.length) {
                            activeQueryId = queryId;
                        }
                        
                        // Get pagination
                        var paginationQueryParam = activeQueryId + "PgNo";
                        var paginationFromURL = klevu.dom.helpers.getQueryStringValue(paginationQueryParam);
                        var paginationValuesQueryParam = 0;
                        
                        // Check if we're restoring from popstate
                        var isRestoringFromPopstate = klevu.getObjectPath(scope.kScope, "element.kScope.isRestoringFromPopstate");
                        
                        // Calculate pagination from meta
                        var activeQueryMeta = klevu.getObjectPath(data, "template.query." + activeQueryId + ".meta");
                        var calculatedPage = 0;
                        if (activeQueryMeta) {
                            var productListLimit = activeQueryMeta.noOfResults;
                            if (productListLimit > 0 && activeQueryMeta.offset !== undefined && activeQueryMeta.offset !== null) {
                                calculatedPage = Math.ceil(activeQueryMeta.offset / productListLimit) + 1;
                            }
                        }
                        
                        // Priority: If restoring from popstate and URL has pagination, use URL value
                        // Otherwise, use calculated value if available, fallback to URL value
                        if (isRestoringFromPopstate === true && paginationFromURL && paginationFromURL.length) {
                            paginationValuesQueryParam = Number(paginationFromURL);
                            // Clear flag after results have rendered to allow future updates
                            setTimeout(function() {
                                klevu.setObjectPath(scope.kScope, "element.kScope.isRestoringFromPopstate", false);
                            }, 1500);
                            // Don't update URL during restoration - it's already correct
                            // But continue to update filters if needed
                        } else if (calculatedPage > 0) {
                            // Use calculated value if available
                            paginationValuesQueryParam = calculatedPage;
                        } else if (paginationFromURL && paginationFromURL.length) {
                            // Fallback to URL value
                            paginationValuesQueryParam = Number(paginationFromURL);
                        } else {
                            paginationValuesQueryParam = 1;
                        }
                        
                        // If restoring from popstate, skip URL update entirely
                        if (isRestoringFromPopstate === true) {
                            return;
                        }
                        
                        // Get filters
                        var filtersString = klevu.search.modules.addPaginationToURL.base.serializeFilters(data, activeQueryId);
                        
                        var searchPath = window.location.search;
                        var updatedPath = searchPath;

                        // Update pagination in URL
                        if (paginationValuesQueryParam > 1) {
                            updatedPath = klevu.dom.helpers.updateQueryStringParameter(updatedPath, paginationQueryParam, paginationValuesQueryParam);
                        } else {
                            updatedPath = updatedPath.replace(new RegExp('[?&]' + paginationQueryParam + '=[^&]*'), '');
                            if (updatedPath.charAt(0) === '&') {
                                updatedPath = '?' + updatedPath.substring(1);
                            }
                        }

                        // Update filters in URL
                        if (filtersString && filtersString.length > 0) {
                            updatedPath = klevu.dom.helpers.updateQueryStringParameter(updatedPath, "Filters", encodeURIComponent(filtersString));
                        } else {
                            updatedPath = updatedPath.replace(new RegExp('[?&]Filters=[^&]*'), '');
                            if (updatedPath.charAt(0) === '&') {
                                updatedPath = '?' + updatedPath.substring(1);
                            }
                        }
                        
                        // Clean up URL if it starts with & or has double &
                        updatedPath = updatedPath.replace(/&+/g, '&').replace(/^\?&/, '?').replace(/^&/, '?');

                        if ('undefined' !== typeof window.history && 'undefined' !== typeof window.history.pushState) {
                            var newUrl = window.location.pathname + (updatedPath.length > 0 ? updatedPath : '');
                            var state = {
                                page: paginationValuesQueryParam,
                                filters: filtersString
                            };
                            window.history.pushState(state, "", newUrl);
                        } else {
                            console.log("This browser does not have the support of window.history or window.history.pushState");
                        }
                    }
                },

                /**
                 * Get and update pagination and filters from URL
                 */
                getAndUpdatePagination: function(data, scope, queryId) {
                    var hasAlreadyTriggered = klevu.getObjectPath(scope.kScope, "element.kScope.getAndUpdatePaginationTriggered");
                    if (hasAlreadyTriggered === true) {
                        return;
                    }
                    
                    var matchedQueryParamId = "";
                    var matchedQueryParamValue = "";
                    var recordQueries = klevu.getObjectPath(data, "request.current.recordQueries");
                    if (recordQueries && recordQueries.length) {
                        klevu.each(recordQueries, function(key, query) {
                            if (query.id) {
                                var paginationFromURL = klevu.dom.helpers.getQueryStringValue(query.id + "PgNo");
                                if (paginationFromURL && paginationFromURL.length) {
                                    matchedQueryParamId = query.id;
                                    matchedQueryParamValue = paginationFromURL;
                                }
                            }
                        });
                    }
                    
                    klevu.setObjectPath(scope.kScope, "element.kScope.getAndUpdatePaginationTriggered", true);
                    var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");
                    if (queryId && queryId.length) {
                        activeQueryId = queryId;
                    } else if (matchedQueryParamId.length && matchedQueryParamValue.length) {
                        activeQueryId = matchedQueryParamId;
                        var storage = klevu.getSetting(scope.kScope.settings, "settings.storage");
                        if (storage.tabs) {
                            storage.tabs.setStorage("local");
                            storage.tabs.mergeFromGlobal();
                            storage.tabs.addElement("active", activeQueryId);
                            storage.tabs.mergeToGlobal();
                        }
                    }

                    // Restore pagination from URL
                    var paginationQueryParam = activeQueryId + "PgNo";
                    var paginationFromURL = klevu.dom.helpers.getQueryStringValue(paginationQueryParam);
                    paginationFromURL = Number(paginationFromURL);
                    if (paginationFromURL && paginationFromURL > 1) {
                        var recordQueries = klevu.getObjectPath(data, "request.current.recordQueries");
                        if (recordQueries.length) {
                            klevu.each(recordQueries, function(key, recordQuery) {
                                if (recordQuery.id === activeQueryId) {
                                    var limit = klevu.getObjectPath(recordQuery, "settings.limit");
                                    limit = Number(limit);
                                    if (limit > 0) {
                                        var expectedOffset = (paginationFromURL - 1) * limit;
                                        klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                                    }
                                }
                            });
                        }
                    }

                    // Restore filters from URL
                    var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                    if (filtersFromURL && filtersFromURL.length > 0) {
                        try {
                            filtersFromURL = decodeURIComponent(filtersFromURL);
                            var parsedFilters = klevu.search.modules.addPaginationToURL.base.parseFiltersFromURL(filtersFromURL);
                            if (parsedFilters && parsedFilters.length > 0) {
                                klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", parsedFilters);
                            } else {
                                // Reset filters if empty
                                klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", []);
                            }
                        } catch (e) {
                            console.warn("Error parsing filters from URL:", e);
                        }
                    } else {
                        // Reset filters if not in URL
                        klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", []);
                    }
                },
                
                /**
                 * Update payload on popstate event - rebuild filters and pagination from URL
                 */
                updatePayloadOnPopState: function(data, scope, queryId) {
                    var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");
                    if (queryId && queryId.length) {
                        activeQueryId = queryId;
                    }
                    
                    // Reset trigger flag to allow re-processing
                    klevu.setObjectPath(scope.kScope, "element.kScope.getAndUpdatePaginationTriggered", false);
                    
                    // Restore pagination
                    var paginationQueryParam = activeQueryId + "PgNo";
                    var paginationFromURL = klevu.dom.helpers.getQueryStringValue(paginationQueryParam);
                    paginationFromURL = Number(paginationFromURL) || 1;
                    
                    var recordQueries = klevu.getObjectPath(data, "request.current.recordQueries");
                    if (recordQueries && recordQueries.length) {
                        klevu.each(recordQueries, function(key, recordQuery) {
                            if (recordQuery.id === activeQueryId) {
                                var limit = klevu.getObjectPath(recordQuery, "settings.limit");
                                limit = Number(limit) || 20;
                                var expectedOffset = (paginationFromURL - 1) * limit;
                                
                                // Set offset in both localOverrides and request to ensure it persists
                                klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                                
                                // Also update the recordQuery directly to ensure it's used
                                if (recordQuery.settings) {
                                    recordQuery.settings.offset = expectedOffset;
                                }
                            }
                        });
                    }
                    
                    // Also set offset directly in scope to ensure it's available when results render
                    if (scope && scope.kScope && scope.kScope.request && scope.kScope.request.current) {
                        var currentRecordQueries = scope.kScope.request.current.recordQueries;
                        if (currentRecordQueries && currentRecordQueries.length) {
                            klevu.each(currentRecordQueries, function(key, recordQuery) {
                                if (recordQuery.id === activeQueryId) {
                                    var limit = klevu.getObjectPath(recordQuery, "settings.limit");
                                    limit = Number(limit) || 20;
                                    var expectedOffset = (paginationFromURL - 1) * limit;
                                    klevu.setObjectPath(scope.kScope, "request.current.recordQueries[" + key + "].settings.offset", expectedOffset);
                                }
                            });
                        }
                    }
                    
                    // Restore filters
                    var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                    if (filtersFromURL && filtersFromURL.length > 0) {
                        try {
                            filtersFromURL = decodeURIComponent(filtersFromURL);
                            var parsedFilters = klevu.search.modules.addPaginationToURL.base.parseFiltersFromURL(filtersFromURL);
                            if (parsedFilters && parsedFilters.length > 0) {
                                klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", parsedFilters);
                            } else {
                                klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", []);
                            }
                        } catch (e) {
                            console.warn("Error parsing filters from URL on popstate:", e);
                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", []);
                        }
                    } else {
                        klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", []);
                    }
                }
            },
            build: true
        }
    });

    klevu.coreEvent.attach("shiftWorshipLandingOverride", {
        name: "attachToShiftWorshipLandingOverride",
        fire: function () {
            klevu.setObjectPath(klevu.settings, "flags.shiftWorshipOverridesActive", true);
            
            klevu.modifyRequest("landing", function(data, scope){
                // Return up to 100 options per filter (Klevu default is 10)
                klevu.each(data.request.current.recordQueries, function (key, query) {
                    klevu.setObjectPath(query, "filters.filtersToReturn.options.limit", 100);
                });
                klevu.search.modules.addPaginationToURL.base.getAndUpdatePagination(data, scope);
            });

            klevu.afterTemplateRender("landing", function(data, scope){
                klevu.search.modules.addPaginationToURL.base.setPagination(data, scope);
            });

            klevu.afterTemplateRender("landing", function(data, scope){
                var scrollPosition = sessionStorage.getItem('klevu_scroll_position');
                if (scrollPosition) {
                    setTimeout(function() {
                        window.scrollTo(0, parseInt(scrollPosition));
                        sessionStorage.removeItem('klevu_scroll_position');
                    }, 100);
                }
            });

            klevu({
                powerUp: {
                    landing: true
                }
            });
        }
    });

    klevu.coreEvent.attach("shiftWorshipCatnavOverride", {
        name: "attachToShiftWorshipCatnavOverride",
        fire: function () {
            klevu.setObjectPath(klevu.settings, "flags.shiftWorshipOverridesActive", true);
            
            klevu.modifyRequest("catnav", function(data, scope){
                // Return up to 100 options per filter (Klevu default is 10)
                klevu.each(data.request.current.recordQueries, function (key, query) {
                    klevu.setObjectPath(query, "filters.filtersToReturn.options.limit", 100);
                });
                const pathname = window.location.pathname;
                const isProducerPage = pathname.includes('collections/shift-worship') ||
                                       pathname.includes('collections/centerline-new-media') ||
                                       pathname.includes('collections/myk');
                if (isProducerPage) {
                    const urlParams = new URLSearchParams(window.location.search);
                    if (!urlParams.get('Filters')) {
                        urlParams.set('Filters', 'type:Collections');
                        window.history.replaceState({}, '', window.location.pathname + '?' + urlParams.toString());
                    }
                }

                klevu.search.modules.addPaginationToURL.base.getAndUpdatePagination(data, scope);
            });

            klevu.afterTemplateRender("catnav", function(data, scope){
                klevu.search.modules.addPaginationToURL.base.setPagination(data, scope);
            });

            klevu.afterTemplateRender("catnav", function(data, scope){
                var scrollPosition = sessionStorage.getItem('klevu_scroll_position');
                if (scrollPosition) {
                    setTimeout(function() {
                        window.scrollTo(0, parseInt(scrollPosition));
                        sessionStorage.removeItem('klevu_scroll_position');
                    }, 100);
                }
            });

            klevu({
                powerUp: {
                    catnav: true
                }
            });
        }
    });

    // Store scroll position when navigating to product pages
    document.addEventListener('DOMContentLoaded', function() {
        // Listen for clicks on product links within Klevu results
        document.addEventListener('click', function(e) {
            var target = e.target.closest('a');
            if (target && target.href && target.href.includes('/products/')) {
                // Check if we're on a Klevu results page
                if (window.location.pathname.includes('/search') || 
                    document.querySelector('[ku-container]') || 
                    document.querySelector('.kuSearchResultsPageContainer')) {
                    // Store current scroll position
                    sessionStorage.setItem('klevu_scroll_position', window.pageYOffset.toString());
                }
            }
        });
        
        // Listen for filter changes to update URL
        setTimeout(function() {
            // Listen for filter checkbox/button clicks
            document.addEventListener('click', function(e) {
                var filterElement = e.target.closest('.kuFilterBox, .kufacet, [data-filter], .ku-filter input, .kuFilterContainer input');
                if (filterElement && (window.location.pathname.includes('/search') || 
                    document.querySelector('[ku-container]') || 
                    document.querySelector('.kuSearchResultsPageContainer'))) {
                    // Delay to allow Klevu to process the filter change
                    setTimeout(function() {
                        try {
                            var klevuScopes = klevu.getObjectPath(klevu, "scope") || klevu.getObjectPath(klevu, "settings.scope") || klevu.scope;
                            if (klevuScopes) {
                                klevu.each(klevuScopes, function(key, scope) {
                                    if (scope && scope.element && scope.element.kScope) {
                                        var activeQueryId = klevu.getObjectPath(scope.element.kScope, "context.activeQueryId");
                                        if (activeQueryId) {
                                            var data = {
                                                context: {
                                                    activeQueryId: activeQueryId
                                                },
                                                template: {
                                                    query: klevu.getObjectPath(scope.element.kScope, "template.query")
                                                }
                                            };
                                            klevu.search.modules.addPaginationToURL.base.setPagination(data, scope, activeQueryId);
                                        }
                                    }
                                });
                            }
                        } catch (err) {
                            console.warn("Error updating URL on filter change:", err);
                        }
                    }, 300);
                }
            });
        }, 1000);

        // Enhanced browser back/forward navigation handling
        window.addEventListener('popstate', function(event) {
            setTimeout(function() {
                // Check if we're on a Klevu results page
                if (window.location.pathname.includes('/search') || 
                    document.querySelector('[ku-container]') || 
                    document.querySelector('.kuSearchResultsPageContainer')) {
                    
                    var klevuScopes = null;
                    
                    klevuScopes = klevu.getObjectPath(klevu, "scope");
                    
                    if (!klevuScopes) {
                        klevuScopes = klevu.getObjectPath(klevu, "settings.scope");
                    }
                    
                    if (!klevuScopes) {
                        klevuScopes = klevu.scope;
                    }
                    
                    if (!klevuScopes) {
                        if (klevu.search && klevu.search.refresh) {
                            klevu.search.refresh();
                        } else if (klevu.refresh) {
                            klevu.refresh();
                        }
                    }
                    
                    if (klevuScopes) {
                        klevu.each(klevuScopes, function(key, scope) {
                            if (scope && scope.element && scope.element.kScope) {
                                // Set flag to prevent URL updates during restoration
                                klevu.setObjectPath(scope.element.kScope, "element.kScope.isRestoringFromPopstate", true);
                                
                                // Update payload from URL (filters and pagination)
                                var data = {
                                    context: {
                                        activeQueryId: klevu.getObjectPath(scope.element.kScope, "context.activeQueryId")
                                    },
                                    request: {
                                        current: {
                                            recordQueries: klevu.getObjectPath(scope.element.kScope, "request.current.recordQueries")
                                        }
                                    },
                                    template: {
                                        query: klevu.getObjectPath(scope.element.kScope, "template.query")
                                    }
                                };
                                
                                // Restore filters and pagination from URL
                                klevu.search.modules.addPaginationToURL.base.updatePayloadOnPopState(data, scope);
                                
                                // Reset pagination trigger flag
                                klevu.setObjectPath(scope.element.kScope, "element.kScope.getAndUpdatePaginationTriggered", false);

                                // Trigger search to re-render with restored state
                                if (scope.element.kScope.refresh) {
                                    scope.element.kScope.refresh();
                                } else if (scope.element.kScope.render) {
                                    scope.element.kScope.render();
                                } else {
                                    var recordQueries = klevu.getObjectPath(scope.element.kScope, "request.current.recordQueries");
                                    if (recordQueries && recordQueries.length > 0) {
                                        // Get the search term from URL or input
                                        var searchInput = document.querySelector('input[ku-search-input]');
                                        var searchTerm = "";
                                        if (searchInput) {
                                            searchTerm = searchInput.value || "";
                                        } else {
                                            var urlParams = new URLSearchParams(window.location.search);
                                            searchTerm = urlParams.get('q') || "";
                                        }
                                        
                                        // Trigger search with current term to restore state
                                        if (scope.element.kScope.search) {
                                            scope.element.kScope.search(searchTerm);
                                        } else if (scope.element.kScope.chains && scope.element.kScope.chains.events && scope.element.kScope.chains.events.keyUp) {
                                            scope.element.kScope.chains.events.keyUp.fire(searchTerm);
                                        }
                                    }
                                }
                            }
                        });
                    } else {
                        if (window.location.pathname.includes('/search')) {
                            var urlParams = new URLSearchParams(window.location.search);
                            var searchTerm = urlParams.get('q');
                            
                            if (searchTerm) {
                                var allInputs = document.querySelectorAll('input[type="text"], input[type="search"]');
                                
                                allInputs.forEach(function(input, index) {
                                    if (input.value === searchTerm || input.placeholder && input.placeholder.toLowerCase().includes('search')) {
                                        input.value = searchTerm;
                                        input.dispatchEvent(new Event('input', { bubbles: true }));
                                        input.dispatchEvent(new Event('change', { bubbles: true }));
                                    }
                                });
                            }
                        }
                        
                        
                        var klevuElements = document.querySelectorAll('[ku-container], .kuSearchResultsPageContainer, [data-ku-container]');
                        
                        klevuElements.forEach(function(element, index) {
                            element.dispatchEvent(new Event('focus', { bubbles: true }));
                            element.dispatchEvent(new Event('blur', { bubbles: true }));
                            element.dispatchEvent(new Event('change', { bubbles: true }));
                        });
                        
                        window.dispatchEvent(new Event('resize'));
                        
                        var paginationElements = document.querySelectorAll('.kuPaginationContainer a, .ku-pagination a, [data-ku-pagination], .pagination a, .pagination-container a, .kuPagination a, .ku-pagination-container a, [ku-pagination] a, .ku-pagination-wrapper a');
                        
                        if (paginationElements.length === 0) {
                            var allLinks = document.querySelectorAll('a');
                            var pageLinks = [];
                            allLinks.forEach(function(link) {
                                var text = link.textContent.trim();
                                var href = link.getAttribute('href') || '';
                                if ((text.match(/^\d+$/) && parseInt(text) > 0) || href.includes('PgNo=')) {
                                    pageLinks.push(link);
                                }
                            });
                            paginationElements = pageLinks;
                        }
                        
                        var currentPage = null;
                        var urlParams = new URLSearchParams(window.location.search);
                        for (var key of urlParams.keys()) {
                            if (key.includes('PgNo')) {
                                currentPage = urlParams.get(key);
                                break;
                            }
                        }
                        
                        if (currentPage && paginationElements.length > 0) {
                            paginationElements.forEach(function(element, index) {
                                var elementText = element.textContent.trim();
                                var elementHref = element.getAttribute('href') || '';
                                
                                if (elementText === currentPage || 
                                    elementHref.includes('PgNo=' + currentPage) ||
                                    elementHref.includes('page=' + currentPage)) {
                                    element.click();
                                }
                            });
                        }
                        
                        try {
                            var allElements = document.querySelectorAll('*');
                            allElements.forEach(function(element) {
                                if (element.kScope && element.kScope.element && element.kScope.element.kScope) {
                                    klevu.setObjectPath(element.kScope.element.kScope, "element.kScope.getAndUpdatePaginationTriggered", false);
                                }
                            });
                        } catch (e) {
                        }
                        
                        try {
                            var klevuContainer = document.querySelector('.kuSearchResultsPageContainer, .klevuLanding');
                            if (klevuContainer) {
                                klevuContainer.dispatchEvent(new CustomEvent('klevu:refresh', { bubbles: true }));
                                klevuContainer.dispatchEvent(new CustomEvent('klevu:update', { bubbles: true }));
                                klevuContainer.dispatchEvent(new CustomEvent('klevu:reload', { bubbles: true }));
                            }
                            
                            var mainContainer = document.querySelector('[ku-container]');
                            if (mainContainer) {
                                mainContainer.dispatchEvent(new CustomEvent('klevu:refresh', { bubbles: true }));
                                mainContainer.dispatchEvent(new CustomEvent('klevu:update', { bubbles: true }));
                            }
                        } catch (e) {
                        }
                        
                        setTimeout(function() {
                            var filterElements = document.querySelectorAll('.kuFilterContainer input, .ku-sort select, .ku-filter input');
                            
                            if (filterElements.length > 0) {
                                filterElements[0].click();
                                
                                setTimeout(function() {
                                    filterElements[0].click();
                                }, 100);
                            }
                        }, 200);
                    }
                    
                    var scrollPosition = sessionStorage.getItem('klevu_scroll_position');
                    if (scrollPosition) {
                        window.scrollTo(0, parseInt(scrollPosition));
                        sessionStorage.removeItem('klevu_scroll_position');
                    }
                }
            }, 500); // delay to ensure Klevu is fully loaded
        });
    });
    
    } // end initializeKlevuOverrides
    
})();
